// import logo from "./logo.svg";
import React, { useState } from 'react';
import './App.css';
import MyRoutes from './Routes';
// import Home from "./containers/Login";
import { Provider } from 'react-redux';
import { store, persistor } from './utils/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { IntlProvider } from 'react-intl';
import messages from './language/en.json';

function App() {
  const states = store.getState();
  const messagesValue = states.langReducer.data;
  const [locale, setLocale] = useState('en');
  const messagesLocal = JSON.parse(localStorage.getItem('alllang'));

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App ffr">
          <IntlProvider locale={locale} messages={messagesLocal  || messages    }>
            <MyRoutes />
          </IntlProvider>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
